import { appSelect } from "@entities/app/model/app.slice";
import { authInfoSelect } from "@entities/auth";
import { LineChart } from "@pages/dashboard/plugins/components/charts";
import { calcSortedDataChart } from "@pages/rkeeper/components/consts";
import { API_DATE_FORMAT } from "@utils/const";
import { Chart, Filler } from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";
import dayjs from "dayjs";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import * as S from "./style.styled";

Chart.register(Filler, annotationPlugin);

export function Plag0() {
  const { shop } = useSelector(authInfoSelect);
  const { from, to } = useSelector(appSelect).dateRange;

  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [chartData, setChartData] = useState<any>(undefined);

  const urlForRemains = useMemo(() => {
    const startDate = from
      ? dayjs(from, API_DATE_FORMAT).format(API_DATE_FORMAT)
      : "2024-01-01";
    const endDate = to
      ? dayjs(to, API_DATE_FORMAT).format(API_DATE_FORMAT)
      : "2024-11-01";

    if (!shop?.id) return null;
    return `${process.env.REACT_APP_API_URL}/shops/${shop.id}/reports/revenue/station/days?from=${startDate}&to=${endDate}`;
  }, [from, to, shop]);

  useEffect(() => {
    if (!urlForRemains || !shop) return;

    setLoading(true);

    fetch(urlForRemains, {
      headers: {
        accept: "application/json",
        Authorization: `${localStorage.getItem("accessToken")}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => setData(data))
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  }, [urlForRemains, shop]);

  useEffect(() => {
    if (Array.isArray(data)) {
      setChartData(
        calcSortedDataChart(
          data.filter((i) => i.CURRENCYTYPE !== "Платежные карты")
        )
      );
    } else {
      setChartData(undefined);
    }
  }, [data]);

  return (
    <S.Palg1Wrap>
      <S.Header>Финансы</S.Header>
      {!loading && <LineChart dataSource={chartData} />}
      <style>
        {`
          .chartjs-render-monitor {
            position: relative;
          }
          .chartjs-render-monitor .tick {
            background-color: blue;
            color: white;
            padding: 2px 4px;
            border-radius: 3px;
          }
        `}
      </style>
    </S.Palg1Wrap>
  );
}
